import React, { useEffect, lazy } from 'react';
import { Route } from 'react-router-dom';
import { useLocation, Switch } from 'react-router-dom';
import ReactGA from 'react-ga';

import * as serviceWorker from './serviceWorker';

import withSuspense from 'utils/suspense';

import 'bootstrap/dist/css/bootstrap.min.css';

serviceWorker.unregister();

const Login = lazy(() => import(/* webpackChunkName: 'HomeRoutes' */ './modules/home/pages/login/login'));
const Home = lazy(() => import(/* webpackChunkName: 'HomeRoutes' */ './modules/home/pages/landing'));
const NotFoundPage = lazy(() => import(/* webpackChunkName: 'HomeRoutes' */ './modules/home/pages/page-not-found/page-not-found'));
const Dashboard = lazy(() => import(/* webpackChunkName: 'ProjectPage' */ './modules/dashboard/routes'));


// Initialize Google Analytics
ReactGA.initialize(process.env.REACT_APP_GA_CODE, { debug: process.env.NODE_ENV !== 'production' });

const trackPage = page => {
  ReactGA.set({ page });
  ReactGA.pageview(page);
};

const App = () => {
  const location = useLocation();

  useEffect(() => {
    const page = location.pathname;
    trackPage(page);
  }, [location]);

  return (
    <Switch>
      <Route exact path="/" component={withSuspense(Home)} />
      <Route path="/signup" component={withSuspense(Login)} />
      <Route path="/login" component={withSuspense(Login)} />
      <Route path="/dashboard" render={withSuspense(Dashboard)} />
      <Route component={withSuspense(NotFoundPage)} />
    </Switch>
  );
}

export default App;

